import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import HeadingAndSupportingTextWithActions, {
  HeadingAndSupportingTextWithActionsProps,
} from '../HeadingAndSupportingText/HeadingAndSupportingTextWithActions';
import Button, { ButtonProps } from 'src/app/atoms/Button/Button';
import TestimonialVideoCardCarousel from '../TestimonialVideoCardCarousel/TestimonialVideoCardCarousel';
import { TestimonialCardProps } from '../TestimonialCard/TestimonialCard';

interface VideoCardCarouselWithTextBlockProps {
  heading: HeadingAndSupportingTextWithActionsProps['heading'];
  supportingText: HeadingAndSupportingTextWithActionsProps['supportingText'];
  button?: ButtonProps;
  cards: TestimonialCardProps[];
}

const TestimonialVideoCardCarouselWithTextBlock = ({
  heading,
  supportingText,
  button,
  cards,
}: VideoCardCarouselWithTextBlockProps): JSX.Element => (
  <Stack
    direction='column'
    gap='spacing-4xl'
    gapSm='spacing-3xl'
  >
    <HeadingAndSupportingTextWithActions
      maxWidth='width-xl'
      heading={heading}
      supportingText={supportingText}
      actions={
        button && (
          <Stack hideOn='lg'>
            <Button {...button}>{button.children}</Button>
          </Stack>
        )
      }
    />
    <TestimonialVideoCardCarousel cards={cards} />
    {button && (
      <Stack
        showOn='lg'
        maxWidth='width-xxs'
        maxWidthSm='width-xs'
      >
        <Button {...button}>{button.children}</Button>
      </Stack>
    )}
  </Stack>
);

export default TestimonialVideoCardCarouselWithTextBlock;
